// src/pages/Solutions.js
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SolutionsSection from '../../components/SolutionsSection';
import ProductionsSection from '../../components/ProductionsSection';
import ProductModulesSection from '../../components/ProductModulesSection';
import ImpactSection from '../../components/ImpactSection';
import DeploymentSection from '../../components/DeploymentSection';
import ToSuccessStoriesSection from '../../components/ToSuccessStoriesSection';

import OrdanceSurvey from "../../assets/images/OrdanceSurvey.png"
import XRENEWABLE from "../../assets/images/XRENEWABLE.png"
import WAVE3 from "../../assets/images/wave3.png"

import BioIcon from "../../assets/images/bio.svg"
import PictureIcon from "../../assets/images/picture.svg"
import DuidieIcon from "../../assets/images/duidie.svg"
import BoxIcon from "../../assets/images/box.svg"
import POIIcon from "../../assets/images/poi.svg"

const SpacetimeInfraPlan = () => {
     const modules = [
    {
      icon: BioIcon,
      title: "Accessibility & Equity Analytics",
      desc: "Evaluates service coverage, travel time, and social equity",
      useCase: "Transport | health | education planning"
    },
    {
      icon: PictureIcon,
      title: "Scenario & Impact Simulator",
      desc: "Tests “what-if” policies or investment strategies",
      useCase: "Long-term infrastructure resilience modelling"
    },
    {
      icon: DuidieIcon,
      title: "Data Integration Layer",
      desc: "Connects with GIS, BIM, and national spatial datasets",
      useCase: "Streamlined planning workflows"
    },
    {
      icon: BoxIcon,
      title: "Infrastructure Siting Model",
      desc: "AI-assisted site selection based on demand, constraints, and cost",
      useCase: "Public-service | facility planning"
    },
    {
      icon: POIIcon,
      title: "Renewable & EV Network Optimiser",
      desc: "Identifies optimal charging-site and renewable-hub locations",
      useCase: "EV rollout | solar | battery planning"
    },
  ];
  const impacts = [
    {
      value: "+40%",
      label: "Charging-site efficiency",
      source: "XRenewable pilot"
    },
    {
      value: "-25%",
      label: "Planning-cycle time",
      source: "OS UK prototype"
    },
    {
      value: "+15%",
      label: "Accessibility equity index",
      source: "Regional testbed"
    },
    {
      value: "-30%",
      label: "Data-integration time",
      source: "Local authority trial"
    }
  ];
  const options = [
    "Cloud SaaS or on-premise installations",
    "Integrates with ESRI ArcGIS, QGIS, and national data APIs",
    "Outputs compatible with BIM and ESG reporting frameworks"
  ];
  return (
    <div>
      <Header />
      <SolutionsSection
        title="Infrastructure & Renewable Planning Intelligence"
        subtitle="Designing equitable, sustainable infrastructure through spatial AI."
      />
      <ProductionsSection
        backgroundImage={WAVE3}
        title="Spacetime InfraPlan™"
        descriptions={[
            "InfraPlan™ helps governments, utilities, and developers plan public and energy infrastructure using geospatial AI.",
            "It combines accessibility, environmental, and demographic data to guide where to build, how to optimise netorks, and how to ensure fairness and sustainability."
        ]}
        logos={[
            {
                src:OrdanceSurvey,
                alt: "Ordance Survey",
                href: "#"
            },
            {
                src:XRENEWABLE,
                alt: "XRENEWABLE",
                href: "#"
            }
        ]}
      />
      <ProductModulesSection modules={modules}/>
      <ImpactSection impacts={impacts}/>
      <DeploymentSection options={options}/>
      <ToSuccessStoriesSection 
        title="Build the foundations of sustainable, data-driven infrastructure with Spacetime InfraPlan™." />
      <Footer/>
    </div>
  );
};

export default SpacetimeInfraPlan;
